import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep12 = (state) => state.get('step12');

const makeSelectStep12 = () => createSelector(
  selectStep12,
  (step12State) => ({
    attachDocuments: mapWithDefault(step12State, () => step12State.getIn(['form', 'attachDocuments']).toJS(), ''),
    uploadPercentage: mapWithDefault(step12State, () => step12State.getIn(['form', 'uploadPercentage']), ''),
    progressBarVisibility: mapWithDefault(step12State, () => step12State.getIn(['form', 'progressBarVisibility']), ''),
  })
);

export {
  makeSelectStep12,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step12/selectors.js